export default {
  tenderList: {
    listSeparator: '、',
    columns: {
      tenderCode: '招标编号',
      title: '招标标题',
      status: '招标状态',
      transportModes: '运输业务类型',
      tenderCompanyName: '招标单位',
      tenderCompany: '招标单位',
      startTime: '开始时间',
      endTime: '结束时间',
      tenderType: '招标类型',
      bidderVisibility: '投标人可见度',
      biddingRounds: '可投标轮次',
      requireDeposit: '是否需缴纳保证金',
      depositAmount: '保证金金额（CNY）',
      depositDeadline: '保证金缴纳截止时间',
      creator: '创建人',
      createTime: '创建时间',
      updater: '更新人',
      updateTime: '更新时间',
      invitationMode: '招标方式',
      currentRound: '当前轮次',
      currentRoundStartTime: '开始时间',
      currentRoundEndTime: '结束时间',
      createdBy: '创建人',
      dateCreated: '创建时间',
      operations: '操作'
    },
    filters: {
      tenderCode: '招标编号',
      tenderCodePlaceholder: '请输入招标编号',
      title: '招标标题',
      titlePlaceholder: '请输入招标标题',
      status: '招标状态',
      statusPlaceholder: '请选择招标状态',
      tenderCompanyName: '招标单位',
      tenderCompanyNamePlaceholder: '请输入招标单位',
      tenderCompany: '招标单位',
      tenderCompanyPlaceholder: '请输入招标单位',
      startTime: '开始时间',
      startTimePlaceholder: '请选择开始时间范围',
      endTime: '结束时间',
      endTimePlaceholder: '请选择结束时间范围',
      tenderType: '招标类型',
      tenderTypePlaceholder: '请选择招标类型',
      transportModes: '运输业务类型',
      transportModesPlaceholder: '请选择运输业务类型',
      bidderVisibility: '投标人可见度',
      bidderVisibilityPlaceholder: '请选择投标人可见度',
      biddingRounds: '可投标轮次',
      biddingRoundsPlaceholder: '请输入可投标轮次',
      requireDeposit: '是否需缴纳保证金',
      requireDepositPlaceholder: '请选择是否需缴纳保证金',
      depositAmount: '保证金金额',
      depositAmountPlaceholder: '请输入保证金金额',
      depositDeadline: '保证金缴纳截止时间',
      depositDeadlinePlaceholder: '请选择保证金缴纳截止时间范围',
      creator: '创建人',
      creatorPlaceholder: '请选择创建人',
      dateCreated: '创建时间',
      dateCreatedPlaceholder: '请选择创建时间范围',
      createTime: '创建时间',
      createTimePlaceholder: '请选择创建时间范围',
      updater: '更新人',
      updaterPlaceholder: '请选择更新人',
      updateTime: '更新时间',
      updateTimePlaceholder: '请选择更新时间范围'
    },
    statuses: {
      draft: '草稿',
      ongoing: '进行中',
      full: '投标已完成-满标',
      underSubscribed: '投标已完成-未满标',
      failed: '流标',
      withdrawn: '撤回',
      evaluating: '评标中',
      awarded: '评标完成'
    },
    transportModes: {
      fcl: '海运整箱（FCL）',
      lcl: '海运拼箱（LCL）',
      air: '空运（AIR）'
    },
    transportModeShortLabels: {
      fcl: '整箱',
      lcl: '拼箱',
      air: '空运'
    },
    tenderTypes: {
      year: '年度招标',
      quarter: '季度招标',
      month: '月度招标'
    },
    bidderVisibility: {
      hidden: '不可见'
    },
    boolean: {
      yes: '是',
      no: '否'
    },
    invitationModes: {
      directed: '定向邀约'
    },
    actions: {
      addTender: '新增招标',
      shareLink: '分享链接',
      sendEmail: '发送邮件',
      batchPublish: '批量发布',
      batchDelete: '批量删除',
      view: '查看',
      edit: '编辑',
      publish: '发布',
      more: '更多',
      withdraw: '撤回',
      delete: '删除',
      copy: '复制'
    },
    messages: {
      loadFailed: '招标列表加载失败，请稍后重试',
      selectOneForShare: '请勾选一行数据后再分享链接',
      selectOneForEmail: '请勾选一行数据后再发送邮件',
      onlyOngoingForEmail: '只有进行中的招标可以发送邀请邮件',
      selectTenderFirst: '请先勾选需要{action}的招标',
      onlyDraftAllowed: '只有草稿状态的招标可以{action}',
      publishConfirmTitle: '确认发布招标',
      publishConfirmContent: '确认发布招标 {code} 吗？发布后状态将变为进行中。',
      batchPublishConfirmContent: '确认发布选中的 {count} 条招标吗？发布后状态将变为进行中。',
      publishSuccess: '成功发布 {count} 条招标',
      publishPartial: '发布完成：成功 {success} 条，失败 {failed} 条，请检查草稿必填信息',
      withdrawConfirmTitle: '确认撤回招标',
      withdrawConfirmContent: '确认撤回招标 {code} 吗？撤回后供应商应标链接立即失效，原招标只能查看或复制。',
      withdrawSuccess: '招标已撤回',
      withdrawFailed: '撤回招标失败，请刷新后重试',
      copyConfirmTitle: '确认复制招标',
      copyConfirmContent: '确认复制招标 {code} 吗？系统将生成一条新的独立草稿。',
      copySuccess: '复制成功，新招标编号为 {code}',
      copyFailed: '复制招标失败，请稍后重试',
      deleteConfirmTitle: '确认删除招标',
      deleteConfirmContent: '确认删除招标 {code} 吗？删除后不可恢复。',
      batchDeleteConfirmContent: '确认删除选中的 {count} 条招标吗？删除后不可恢复。',
      deleteSuccess: '成功删除 {count} 条招标',
      deletePartial: '删除完成：成功 {success} 条，失败 {failed} 条，请刷新后重试',
      deleteFailed: '删除招标失败，请刷新后重试'
    }
  },
  invitationMail: {
    title: '发送邮件',
    template: '邮件模板：',
    templatePlaceholder: '请选择邮件模板',
    preview: '邮件内容预览：',
    companies: '发送公司：',
    companiesPlaceholder: '请选择发送公司',
    privateLinkMask: '【发送后生成专属链接，仅收件人邮件可见】',
    privateLinkHint: '应标专属链接不会在页面展示或复制，仅写入对应供应商联系人的邮件；每家企业的链接和令牌均不同。',
    noEmail: '未填写邮箱',
    emptyTemplate: '未配置可用的招标邀请邮件模板',
    templateLoadFailed: '邮件模板加载失败，请稍后重试',
    selectTemplate: '请选择邮件模板',
    selectCompany: '请至少选择一家有效收件公司',
    sendSuccess: '邮件发送成功，共 {count} 家公司',
    sendFailed: '邮件发送失败，请稍后重试',
    cancel: '取消',
    send: '发送邮件'
  },
  tenderDetail: {
    titles: {
      create: '新增招标',
      edit: '编辑招标',
      view: '招标详情：{title}（{code}）',
      unnamed: '未命名招标'
    },
    steps: {
      basicAndMethod: '基本信息',
      subject: '标的物填写'
    },
    sections: {
      basicInfo: '基本信息',
      invitationMethod: '招标方式',
      supplierList: '供应商列表',
      evaluationTeam: '评标小组',
      bidderInfo: '应标人信息',
      subjectInfo: '标的物信息',
      feeSettings: '费用填报设置',
      routeConfig: '航线配置',
      attachments: '招标附件'
    },
    fields: {
      tenderCode: '招标编号',
      title: '招标标题',
      tenderCompany: '招标单位',
      tenderType: '招标类型',
      cargoType: '货品类型',
      invitationMode: '招标方式',
      bidderVisibility: '投标人可见度',
      startTime: '本轮招标开始时间',
      endTime: '本轮招标结束时间',
      biddingRounds: '可投标轮次',
      maxBidCount: '投标数上限',
      minBidCount: '投标数下限',
      winningBidCount: '可中标数',
      contractStartDate: '合同开始日期',
      contractEndDate: '合同结束日期',
      requireDeposit: '是否缴纳保证金',
      depositAmount: '保证金金额（人民币）',
      depositDeadline: '保证金缴纳截止时间',
      transportModes: '运输业务类型',
      remark: '备注说明'
    },
    tenderCompanies: {
      shokz: '韶音科技'
    },
    columns: {
      index: '序号',
      supplierName: '供应商名称',
      contactName: '联系人',
      email: '邮箱',
      bidStatus: '应标状态',
      qualificationStatus: '应标资格',
      winStatus: '中标状态',
      bidBook: '应标标书',
      operationHistory: '操作历史',
      winningRoutes: '中标信息',
      awardInfo: '中标信息',
      awardPercentage: '中标比例',
      winner: '中标人',
      operation: '操作',
      permit: '权限类型',
      memberRole: '成员角色',
      quoteVisibility: '报价可见时间',
      dataScope: '数据范围',
      department: '部门',
      memberName: '姓名',
      routeCode: '线路代码',
      tenderScheme: '招标方案',
      originCountry: '起运国',
      originPort: '起运港',
      originAirport: '起运机场',
      originCity: '起运地（城市）',
      originWarehouse: '发货仓库',
      destinationCountry: '目的国',
      destinationPort: '目的港',
      destinationAirport: '目的机场',
      destinationCity: '目的地（城市）',
      destinationWarehouse: '目的仓库',
      benchmark: '标杆',
      serviceType: '服务类型',
      transportClause: '运输条款',
      tradeClause: '贸易条款',
      weightKg: '重量（kg）',
      weightKgFcl: '重量(kg)',
      weightKgMixed: '重量(KG)',
      cbm: '体积（CBM）',
      cbmPrototype: '体积(CBM)',
      containerType: '箱型',
      quantity: '数量',
      winnerMerged: '中标人（合并）',
      totalPrice: '总费用',
      comprehensiveScore: '综合分',
      maxPrice: '最高限价(USD)',
      minPrice: '最低限价(USD)',
      tenderRemark: '招标备注',
      priceLimit: '限价',
      remark: '备注'
    },
    attachmentColumns: {
      name: '文件名',
      size: '文件大小',
      uploader: '上传人',
      uploadTime: '上传时间'
    },
    actions: {
      back: '返回',
      cancel: '取消',
      close: '关闭',
      saveDraft: '保存草稿',
      publish: '发布招标',
      edit: '编辑',
      view: '查看',
      confirmQualification: '确认资格',
      openTender: '开标',
      viewOpening: '查看开标详情',
      exportBidInfo: '导出应标信息',
      withdraw: '撤回',
      addSupplier: '添加供应商',
      addMember: '添加成员',
      addRoute: '新增航线',
      batchUpload: '批量上传',
      selectAll: '全选',
      batchDeleteRoutes: '批量删除（{count}）',
      setContainer: '设置箱型',
      collapse: '收起 ▲',
      expand: '展开 ▼',
      saveAsScheme: '保存方案',
      resetDefault: '重置为默认',
      delete: '删除',
      download: '下载',
      nextStep: '下一步：标的物填写',
      prevStep: '返回基本信息'
    },
    placeholders: {
      autoGenerate: '自动生成',
      title: '请输入招标标题',
      tenderCompany: '请选择或输入招标单位',
      tenderType: '请选择招标类型',
      cargoType: '请选择货品类型',
      startTime: '请选择开始时间',
      endTime: '请选择结束时间',
      remark: '请输入备注说明',
      supplierName: '请选择或输入供应商',
      contactName: '请选择联系人',
      email: '请输入邮箱地址',
      permit: '请选择权限类型',
      department: '请选择或输入部门',
      memberName: '请选择或输入姓名',
      currentUserAutoFill: '保存时自动补齐当前创建人',
      routeCode: '自动生成或保存后生成',
      originCountry: '国家必填',
      originPort: '港口选填',
      destinationCountry: '国家必填',
      destinationPort: '港口选填',
      containerType: '请选择箱型'
    },
    validation: {
      titleRequired: '请输入招标标题',
      cargoTypeRequired: '请选择货品类型',
      tenderCompanyRequired: '请选择招标单位',
      tenderTypeRequired: '请选择招标类型',
      startTimeRequired: '请选择本轮招标开始时间',
      endTimeRequired: '请选择本轮招标结束时间',
      endTimeAfterStart: '结束时间必须晚于开始时间',
      endTimeAfterNow: '招标结束时间必须晚于当前时间',
      biddingRoundsRequired: '请输入可投标轮次',
      minBidCountRequired: '请输入投标数下限',
      bidCountRangeInvalid: '投标数下限不能大于投标数上限',
      supplierCountLimit: '供应商数量不能超过投标数上限（{count} 家）',
      winningBidCountRequired: '请输入可中标数',
      contractStartDateRequired: '请选择合同开始日期',
      contractEndDateRequired: '请选择合同结束日期',
      contractEndDateAfterStart: '合同结束日期必须晚于合同开始日期',
      depositAmountRequired: '请输入保证金金额',
      depositDeadlineRequired: '请选择保证金缴纳截止时间',
      transportModeRequired: '请选择运输业务类型',
      supplierRequired: '请至少添加 1 家受邀供应商',
      supplierIncomplete: '请完整选择供应商、联系人并确认联系人邮箱有效',
      evaluationMemberInvalid: '评标小组成员不能重复',
      routeModeRequired: '{mode} 请至少添加 1 条航线',
      routeFieldRequired: '{mode} 第 {index} 条航线的起运国、目的国、服务类型、运输条款和贸易条款均为必填',
      originLocationRequired: '{mode} 第 {index} 条航线已选择港前费用，请填写起运城市或发货仓库',
      destinationLocationRequired: '{mode} 第 {index} 条航线已选择尾程费用，请填写目的城市或收货仓库',
      routeMetricPositive: '{mode} 第 {index} 条航线的重量和体积必须大于 0',
      containerRequired: 'FCL 第 {index} 条航线请至少设置 1 种箱型',
      containerInvalid: 'FCL 第 {index} 条航线存在空箱型、重复箱型或不合法数量',
      priceLimitInvalid: '{mode} 第 {index} 条航线的最低限价和最高限价填写不合法',
      attachmentTypeInvalid: '仅支持 PDF、Word、Excel、JPG、JPEG、PNG 格式文件',
      attachmentSizeLimit: '单个文件不超过 10MB',
      batchUploadFileType: '仅支持上传 .xls、.xlsx 或 .csv 文件',
      batchUploadEmpty: '文件中没有可导入的标的物航线'
    },
    hints: {
      winningBidCount: '每条航线/箱型可中标供应商数量',
      feeSettings: '配置供应商投标时需要填报的费用项目，并按运输业务类型设置是否必填。',
      quantityOptional: '招标方选填；未填写时供应商应标页面保持只读空值。',
      subjectGrid: '表格右侧“列”按钮可配置显示列；带 * 的字段为发布必填；城市、仓库、数量等选填列默认隐藏。',
      tenderSchemeCompositionTitle: '参数构成',
      tenderSchemeCompositionNote: '仅展示招标已填项，只读',
      tenderSchemeDetailTitle: '招标方案明细',
      tenderSchemeCompositionPrefix: '构成：',
      tenderSchemeFormulaSea: '起运国-起运港-起运地（城市）-起运仓库-目的国-目的港-目的地（城市）-目的仓库',
      tenderSchemeFormulaAir: '起运国-起运机场-起运地（城市）-起运仓库-目的国-目的机场-目的地（城市）-目的仓库',
      batchUpload: '在航线表格内右键导出模板，填写后上传 .xls、.xlsx 或 .csv 文件。'
    },
    feeSettings: {
      billingUnit: '计量单位',
      currency: '币种',
      currentScheme: '当前方案：',
      noScheme: '未选择方案',
      saveTitle: '保存费用方案',
      schemeName: '方案名称',
      schemeDescription: '方案描述（可选）',
      schemeNamePlaceholder: '如：美线标准方案',
      schemeDescriptionPlaceholder: '描述该方案适用的场景，方便后续选择',
      setAsDefault: '设为默认方案（新建招标时优先使用）',
      defaultTag: '默认',
      empty: '当前运输业务类型下暂无启用的费用项',
      refresh: '从费用管理重新加载费用项',
      required: '必填',
      optional: '选填',
      minMax: 'Min/Max',
      groups: {
        origin: '港前',
        basic: '干线',
        destination: '尾程'
      }
    },
    batchUpload: {
      downloadTitle: '导出标的物模板',
      downloadDescription: '模板表头与当前运输业务类型的航线表格一致。',
      downloadAll: '下载全部模板',
      rightClickTip: '请在航线表格任意数据单元格上右键，选择“导出 → 导出为 Excel”或“导出为 CSV”。',
      uploadTitle: '上传文件',
      dropHint: '拖拽文件到此处或点击上传',
      fileTypes: '支持 .xls、.xlsx、.csv 文件'
    },
    importErrors: {
      title: '导入校验未通过',
      summary: '共发现 {count} 个问题。整批数据尚未回填，请修正文件后重新导入。',
      sheet: '工作表',
      row: '行',
      column: '字段',
      value: '原始值',
      reason: '问题说明',
      currentDuplicate: '该航线与当前页面已有航线重复'
    },
    subjectOptions: {
      economy: '经济',
      express: '快速',
      enabled: '开启',
      minPrice: '最低',
      maxPrice: '最高',
      none: '无'
    },
    subjectSummary: {
      fcl: '共 {routes} 条航线，{containers} 个箱型配置',
      routes: '共 {routes} 条航线',
      readonlyFooter: '共 {count} 条记录 | 招标方案构成：{formula}'
    },
    awardInfo: {
      title: '中标信息',
      supplierTitle: '{supplier} - 中标信息',
      winnerFallback: '中标人',
      summary: '{count}条线路 · {percentages}',
      subjectRecords: '共 {count} 条记录',
      totalRecords: '共 {count} 条中标记录',
      routeFormula: '线路代码构成：{formula}',
      routeFormulaValue: '起运港-起运地-目的港-目的地-运输业务类型',
      routeFormulaAirValue: '起运机场-起运地-目的机场-目的地-运输业务类型',
      supplierRouteFormula: '招标方案构成：{formula}',
      supplierRouteFormulaValue: '起运国-起运港-起运地（城市）-起运仓库-目的国-目的港-目的地（城市）-目的仓库',
      supplierRouteFormulaAirValue: '起运国-起运机场-起运地（城市）-起运仓库-目的国-目的机场-目的地（城市）-目的仓库',
      routingType: '运输方式',
      transitPort: '中转港',
      validityLegend: '运价有效期',
      transitLegend: '线路信息',
      effectiveDate: '生效日期',
      expiryDate: '截止日期',
      carrier: '船公司/承运人',
      airCarrier: '航空公司/承运人',
      vesselSchedule: '班轮时间',
      flightSchedule: '航班表',
      transitTimeDays: '运输周期',
      freeContainerDays: '目的港免柜期',
      freeStorageDays: '目的港免堆期',
      destClearanceDays: '目的港清关时间',
      airportFreeStorage: '目的机场免存期',
      achievementRate: '时效达成率',
      ddType: 'POD D&D 类型',
      ddMixedDays: 'POD D&D Mixed',
      ddDemurrageDays: 'POD D&D Demurrage',
      ddDetentionDays: 'POD D&D Detention',
      storageDays: 'POD 堆存天数',
      feeSummary: '费用明细',
      transitTime: '时效',
      validity: '有效期',
      ddSummary: 'D&D/免箱期',
      remark: '应标备注',
      day: '天',
      noBid: '暂无应标记录，无法查看中标信息',
      noSupplierAward: '该供应商暂无中标信息',
      supplierLoadFailed: '供应商应标报价加载失败',
      noQuote: '暂无中标应标数据',
      noSubject: '暂无标的物数据'
    },
    attachments: {
      uploadTitle: '点击或拖拽文件到此区域上传',
      supportedTypes: '支持 PDF、Word、Excel、图片格式',
      sizeLimit: '单个文件不超过 10MB',
      uploadedFiles: '已上传文件（{count}）',
      empty: '暂无上传文件'
    },
    permits: {
      fullView: '全程可查看',
      fullEdit: '全程可编辑'
    },
    bidderStatus: {
      bid: { NOT_BID: '未应标', DRAFT: '草稿', SUBMITTED: '已提交' },
      qualification: { UNCONFIRMED: '未确认', CONFIRMED: '已确认' },
      win: { NOT_OPENED: '未开标', WON: '中标', PARTIAL: '部分中标', LOST: '未中标' }
    },
    bidderHistory: {
      title: '{supplier} · 操作历史',
      viewTab: '标书查看历史（{count}）',
      mailTab: '邮件发送历史',
      viewer: '查看人',
      sender: '发送人',
      department: '部门',
      viewType: '查看来源',
      viewTime: '查看时间',
      receiverEmail: '收件邮箱',
      receiverName: '收件人/公司',
      emailType: '邮件类型',
      sendTime: '发送时间',
      emailContent: '邮件内容',
      viewTypes: { BID_VIEW: '标书详情页', CROSS_BID_VIEW: '跨标书评标页' },
      emailTypes: { INVITATION: '招标邮件', AWARD: '中标邮件' }
    },
    opening: {
      confirmTitle: '确认开标',
      confirmContent: '开标后将进入评标中，所有已提交标书对有权限的评标成员可见。确认开标吗？',
      referenceTitle: '补写评标参考值',
      referenceHintPrefix: '当前招标存在',
      referenceSegments: '港前 / 干线 / 尾程',
      referenceHintSuffix: '整段未报价的情况，请从运价库选择参考运价用于评标；补写值将在开标详情页标红展示。',
      confirmAndOpen: '确认补写并开标',
      route: '线路代码',
      missingSuppliers: '缺报价供应商',
      companyUnit: '家',
      feeCategory: '缺失费用段',
      referenceAmount: '参考金额',
      referenceRate: '参考运价',
      referenceFootnote: '提示：参考值仅用于本次评标计算，不会回写供应商原始标书。同一线路下所有缺报价供应商将共用所选参考运价。',
      currency: '币种',
      referenceSource: '参考值来源',
      manualSource: '手工填写',
      rateLibrarySource: '运价库',
      selectRate: '从运价库选择',
      changeRate: '更换运价',
      referenceRequired: '请补全所有参考金额',
      checkFailed: '开标检查失败，请刷新后重试',
      success: '开标成功，已进入评标中',
      failed: '开标失败，请刷新后重试',
      feeCategories: { origin: '港前', mainline: '干线', destination: '尾程', whole: '全程' },
      ratePicker: {
        title: '从运价库选择 · {library}',
        hint: '从运价库中选择适合的参考运价，选中后将回填至评标参考值。',
        transportMode: '业务类型',
        containerType: '箱型',
        priceNo: '运价编码',
        source: '运价来源',
        supplier: '供应商',
        originPort: '起运港',
        destinationPort: '目的港',
        originAirport: '起运机场',
        destinationAirport: '目的机场',
        validPeriod: '有效期',
        amountUnavailable: '无法解析',
        select: '选择',
        selected: '已选择',
        selectedPreview: '已选',
        cancel: '取消',
        confirmSelection: '确认选择',
        selectionRequired: '请选择一条参考运价',
        manualTitle: '请手动填写参考值',
        manualUnavailableDescription: '匹配到的运价均无法解析参考金额，请手动填写金额和币种。',
        manualAmount: '参考金额',
        manualAmountRequired: '请输入有效的参考金额',
        empty: '运价库中未找到匹配的运价，请在下方手动填写参考值',
        loadFailed: '运价库查询失败，请稍后重试或手工填写参考值',
        libraries: { fcl: '海运整箱运价', lcl: '海运拼箱运价', air: '空运运价' },
        sources: { inquiry: '询价入库', bidding: '招标入库', manual: '手工录入', system: '系统生成', unknown: '其他' }
      }
    },
    export: { filePrefix: '应标信息' },
    memberRoles: {
      owner: '全程可编辑',
      editor: '项目编辑',
      viewer: '项目查看'
    },
    quoteVisibility: {
      afterOpen: '开标后可见报价',
      afterAward: '定标后可见报价'
    },
    dataScopes: {
      project: '项目全部',
      department: '本部门'
    },
    feeStates: {
      disabled: '取消',
      optional: '选填',
      required: '必填'
    },
    messages: {
      loadFailed: '招标详情加载失败，请稍后重试',
      saveDraftSuccess: '招标草稿保存成功',
      saveDraftFailed: '招标草稿保存失败，请稍后重试',
      publishConfirmTitle: '确认发布招标',
      publishConfirmContent: '发布后招标状态将进入进行中。确认发布吗？',
      publishSuccess: '招标发布成功',
      publishFailed: '招标发布失败，请检查必填信息或刷新后重试',
      publishAttachmentFailed: '草稿已保存，但附件上传失败，招标尚未发布',
      contactLoadFailed: '供应商联系人加载失败，请稍后重试',
      supplierDuplicate: '同一家供应商不能重复添加',
      evaluationDepartmentMismatch: '已过滤非当前部门员工',
      evaluationDepartmentChanged: '部门已变更，请重新选择姓名',
      evaluationPriceHint: '所有权限类型在开标前均不可查看价格',
      transportModeRequired: '请选择 FCL / LCL / AIR 至少一种运输业务类型',
      departmentLoadFailed: '业务部门加载失败，请稍后重试',
      saveDraftAttachmentFailed: '草稿已保存，附件上传失败，请稍后重试',
      attachmentDeleteFailed: '附件删除失败，请稍后重试',
      attachmentDownloadFailed: '附件下载失败，请稍后重试',
      batchUploadSuccess: '已导入 {count} 条标的物航线',
      batchUploadWarehouseUnmatched: '已导入 {count} 条标的物航线，其中 {unmatched} 行目的仓库未匹配唯一基础资料，请在表格中重新选择',
      batchUploadFailed: '批量上传解析失败，请检查文件格式',
      templateDownloadFailed: '标的物模板生成失败',
      containerTypeEmpty: '当前租户暂无已启用的集装箱类型',
      containerTypeLoadFailed: '集装箱类型加载失败，请稍后重试',
      feeSettingsLoadFailed: '费用项加载失败，请稍后重试',
      currencyOptionsLoadFailed: '币种选项加载失败，请稍后重试',
      feeSchemesLoadFailed: '费用方案加载失败，请稍后重试',
      feeSchemeNameRequired: '请输入费用方案名称',
      feeSchemeSaveSuccess: '费用方案保存成功',
      feeSchemeSaveFailed: '费用方案保存失败，请稍后重试',
      feeSchemeDeleteConfirm: '确定删除费用方案“{name}”吗？',
      feeSchemeDeleteSuccess: '费用方案已删除',
      feeSchemeDeleteFailed: '费用方案删除失败，请稍后重试',
      feeSettingsResetSuccess: '已重置为默认费用设置',
      feeSettingsRefreshSuccess: '已从费用管理重新加载费用项',
      bidderHistoryLoadFailed: '操作历史加载失败，请稍后重试',
      confirmQualificationTitle: '确认应标资格',
      confirmQualificationContent: '确认供应商“{supplier}”已满足本轮应标资格吗？',
      qualificationConfirmed: '应标资格已确认',
      noSubmittedBidToExport: '暂无可导出的已提交标书',
      exportSuccess: '应标信息导出成功',
      exportFailed: '应标信息导出失败，请稍后重试'
    }
  },
  evaluation: {
    feeCalculation: {
      pending: '待计算', formula: '单价 {unitRate} × 数量 {quantity}',
      min: '下限 {value}', max: '上限 {value}', result: '计费金额 {amount}',
      weightBreakNote: '干线展示所选重量段的计费金额，总费用按标的重量对应档位计算。'
    },
    title: '开标详情：{title}（{code}）',
    openingTitle: '开标详情',
    status: '评标中',
    hint: '默认展示当前轮所有已提交标书的参与报价；进入本页会按PRD记录各标书查看历史。',
    nonEvaluationHint: '本页面展示已开标的结构化标书并记录查看历史，同时按原型评分公式生成排名。',
    actions: { back: '返回', export: '导出应标信息', setWinner: '设定中标人', newRound: '再次投标' },
    newRound: {
      title: '再次投标',
      suppliers: '选择供应商',
      suppliersPlaceholder: '请选择上一轮资格确认通过的供应商',
      startTime: '开始时间',
      endTime: '结束时间',
      cancel: '取消',
      confirm: '发起下一轮',
      unavailable: '已达到最大投标轮次，或当前轮暂无资格有效的已提交标书',
      supplierRequired: '请至少选择一家供应商',
      timeRequired: '请选择下一轮开始和结束时间',
      timeInvalid: '结束时间必须晚于开始时间，且必须晚于当前时间',
      success: '第 {round} 轮投标已创建，请发送邀请邮件',
      failed: '发起下一轮投标失败，请刷新后重试'
    },
    sections: { filters: '筛选条件', sort: '排序条件' },
    fields: {
      benchmark: '标杆', routeCode: '线路代码', scheme: '招标方案', supplier: '应标人', round: '轮次',
      container: '箱型', weightCbm: '重量/体积', weightBreak: '重量段', currency: '币种',
      originCountry: '起运国', originPort: '起运港', originCity: '起运地（城市）', originWarehouse: '起运仓库',
      destinationCountry: '目的国', destinationPort: '目的港', destinationCity: '目的地', destinationWarehouse: '目的仓库'
    },
    filters: {
      benchmarkPlaceholder: '请选择标杆',
      schemePlaceholder: '请选择招标方案',
      supplierPlaceholder: '请选择应标人',
      roundPlaceholder: '请选择轮次',
      containerPlaceholder: '请选择箱型',
      weightCbmPlaceholder: '请选择重量/体积',
      weightBreakPlaceholder: '请选择重量段（空运）',
      currencyPlaceholder: '请选择币种',
      originCountryPlaceholder: '请选择起运国',
      originPortSeaPlaceholder: '请选择起运港',
      originPortAirPlaceholder: '请选择起运机场',
      originCityPlaceholder: '请选择起运地',
      originWarehousePlaceholder: '请选择起运仓库',
      destinationCountryPlaceholder: '请选择目的国',
      destinationPortSeaPlaceholder: '请选择目的港',
      destinationPortAirPlaceholder: '请选择目的机场',
      destinationCityPlaceholder: '请选择目的地',
      destinationWarehousePlaceholder: '请选择目的仓库'
    },
    options: {
      all: '全部', benchmarkOnly: '仅标杆', nonBenchmark: '非标杆', benchmarkTag: '标杆'
    },
    viewSwitch: '视图切换：',
    bidView: '标书视图',
    scoreView: '分数视图',
    bidSortLabel: '标书视图排序：',
    sortOptions: {
      price: '价格最优', transit: '时效最快', portFront: '港前', mainline: '干线', tail: '尾程',
      mainlineWeightBreak: '干线-{weightBreak}'
    },
    weightBreakOption: '{tier}（{range}）',
    weightBreakHint: '已选重量段 {weightBreak}：干线展示该重量段计费金额用于比较（总费用按标的重量计算），点「{sortOption}」按金额升序',
    scoreSortLabel: '分数视图排序：',
    scoreSortOption: '{score}最高',
    comparisonHint: '点击总费用金额查看费用明细与线路信息；点击招标方案查看完整招标标的物信息。供应商列按当前标书视图排序条件展示。',
    mergeHintPrefix: '带',
    mergeHintTag: '合并N条',
    mergeHintSuffix: '标记的为相同费用多线路合并展示',
    mergeTag: '合并{count}条',
    scoreComparisonHint: '点击具体分数可查看详细评分算法；点击线路代码可查看费用与线路信息；点击招标方案可查看完整招标标的物信息。',
    latest: '最新',
    roundValue: '第 {round} 轮',
    recordCount: '共 {count} 条对比记录',
    common: { yes: '是', no: '否', day: '天' },
    columns: {
      index: '序号', supplier: '应标人', bidBook: '应标标书', round: '投标轮次', scheme: '招标方案',
      routeCode: '线路代码', container: '箱型', weightCbm: '重量(kg) / 体积(CBM)', validity: '运价有效期', carrier: '船公司/航空公司',
      schedule: '班轮/航班星期', transitDays: '运输周期（天）', achievementRate: '综合时效达成率', fees: '费用报价', remark: '应标备注'
    },
    drawers: {
      feeTitle: '费用明细', routeTitle: '招标标的物信息', feeName: '费用名称', currency: '币种',
      segmentSummary: '入库分类汇总',
      amount: '金额', total: '总费用', origin: '起运信息', destination: '目的信息', serviceType: '服务类型',
      composition: '构成', tenderSchemeComposition: '招标方案构成', routeLineCode: '线路代码', routeInfo: '线路信息',
      tenderSchemeFormulaSea: '起运国-起运港-起运地（城市）-起运仓库-目的国-目的港-目的地（城市）-目的仓库', tenderSchemeFormulaAir: '起运国-起运机场-起运地（城市）-起运仓库-目的国-目的机场-目的地（城市）-目的仓库',
      routeLineFormulaSea: '起运港-目的港', routeLineFormulaAir: '起运机场-目的机场',
      carrier: '船公司', airline: '航空公司', sailingSchedule: '班轮时间', flightSchedule: '航班时间',
      transitTime: '运输周期', destinationFreeDetention: '目的港免柜期', destinationFreeStorage: '目的港免堆期',
      destinationClearance: '目的港清关时间', airportFreeStorage: '目的机场免存期', cfsFreeStorage: 'CFS仓库免存期',
      hour: '小时', noFeeItems: '暂无费用项', originAirportFees: '港前', destinationAirportFees: '尾程',
      mergedRouteTip: '多条线路费用相同，已合并展示；点击总费用可切换查看各线路明细',
      maxPrice: '最高限价({currency})', minPrice: '最低限价({currency})', tenderRemark: '招标备注'
    },
    feeCategories: { origin: '港前', basic: '干线', destination: '尾程' },
    segments: { portFront: '港前', mainline: '干线', tail: '尾程' },
    score: {
      drawerNote: '各评分项目均按当前报价行对应的数据库评分记录展示。',
      drawerNoteFclCommercial: '商务分按线路 40HQ/20GP 合成（各行相同）；技术分/综合分按本行箱型标书单独计算。',
      evaluationTable: '评分详情表', evaluationScope: '评估范围', evaluationProject: '评估项目',
      description: '描述', score: '得分', parameterTable: '评分参数表', parameter: '评分参数', value: '数值',
      summaryDescriptions: {
        fclCommercial: `1. 基础数据口径
- 海运整柜成本：基于40HQ×比例+20GP×比例的综合费用
2. 基准成本确定
- 海运基准成本：在同一线路分组内，各承运商海运整柜成本（回标成本）的最低值
3. 成本得分换算
- 成本得分=Max( 0, ( 2 - 每个供应商每条线路回标成本 / 基准成本 ) × 100 )
注：当某条线路成本为基准成本的 2 倍或以上时，得分为 0。`,
        lclCommercial: `1. 基础数据口径
- 海运拼箱成本：基于报价重量段+上季度已闭环（N-3~N-1）的重量段分布进行加权（0~300KG×X%+300~500KG×Y%）后的综合费用
2. 基准成本确定
- 海运拼箱基准成本：在同一线路分组内，所有承运商在2000KG/3000KGS重量段中的综合费用最低值
3. 成本得分换算
- 成本得分=Max( 0, ( 2 - 每个供应商每条线路回标成本 / 基准成本 ) × 100 )
注：当某条线路成本为基准成本的 2 倍或以上时，得分为 0。`,
        airCommercial: `1. 基础数据口径
- 空运成本：基于报价重量段+上季度已闭环（N-3~N-1）的重量段分布进行加权（0~300KG×X%+300~500KG×Y%）后的综合费用
2. 基准成本确定
- 空运基准成本：在同一线路分组内，所有承运商在2000KG/3000KGS重量段中的综合费用最低值
3. 成本得分换算
- 成本得分=Max( 0, ( 2 - 每个供应商每条线路回标成本 / 基准成本 ) × 100 )
注：当某条线路成本为基准成本的 2 倍或以上时，得分为 0。`,
        technical: `1. 修正时效换算
- 修正时效 = 承诺运输周期 / 时效达成率
2. 基准时效确定
- 基准时效：在同一线路分组内，取所有承运商修正时效的最小值
3. 时效得分换算
- 时效得分：Max( 0, ( 2 - 每个供应商每条线路修正时效 / 基准时效 ) × 100 )
注：当某条线路修正时效为基准时效的 2 倍或以上时，得分为 0。`,
        comprehensive: '回标综合得分=成本得分×80%+时效得分×20%'
      }
    },
    messages: {
      loadFailed: '开标详情数据加载失败，请稍后重试',
      exportFailed: '应标信息导出失败，请稍后重试'
    }
  },
  award: {
    title: '设定中标人',
    allocationModalTitle: '跨标书评标 — {code}',
    notificationModalTitle: '确认定标并发送通知 — {code}',
    status: { draft: '定标草稿', committed: '已定标' },
    steps: { allocation: '分配中标结果', notification: '确认/通知' },
    actions: {
      back: '返回', refresh: '刷新状态', retry: '重试', remove: '移除', delete: '删除', addWinner: '添加中标人',
      cancel: '取消', previous: '返回修改', saveDraft: '保存草稿', confirmAllocation: '确定',
      saveAward: '保存定标结果', saveAndSend: '保存定标结果并发送通知邮件', commit: '确认定标'
    },
    result: {
      title: '定标已提交',
      subtitle: '定标版本 {version}，提交时间 {time}'
    },
    allocation: {
      title: '分配中标结果',
      instruction: '先选定中标供应商并设置中标比例，再逐条添加线路代码；每条线路独立展示总费用与综合分。FCL 按箱型分别设定，每个箱型最多 {count} 个中标供应商（不可重复）；LCL/AIR 每条招标方案最多 {count} 个。各箱型 / 航线比例分别合计 ≤ 100%。',
      winnerLimit: '每个定标维度最多 {count} 家中标供应商',
      dimensionCount: '共 {count} 个定标维度',
      noCandidate: '当前维度暂无合格候选报价',
      importAllSupplierPrices: '将全部供应商应标价格导入运价库',
      importAllSupplierPricesHint: '默认仅导入确认中标的报价；勾选后，中标供应商的全部有效报价正常入库，非中标供应商的全部有效报价以禁用草稿状态入库。',
      scheme: '招标方案',
      benchmark: '标杆',
      container: '箱型',
      supplier: '中标供应商',
      supplierPlaceholder: '请选择供应商',
      quote: '中标报价',
      quotePlaceholder: '请选择候选报价',
      percentage: '中标比例',
      percentageWithUnit: '中标比例(%)',
      percentagePlaceholder: '1 - 100',
      routeDetails: '线路明细',
      lineCodes: '线路代码',
      lineCodesPlaceholder: '请选择线路代码',
      totalPrice: '总费用',
      containsReference: '含参考价',
      comprehensiveScore: '综合分',
      operation: '操作',
      total: '比例合计',
      fullAward: '✓ 满标',
      partialAward: '部分中标',
      overAward: '不能超过 100%',
      winnerCount: '{current}/{limit} 个中标供应商',
      noWinner: '暂无中标人，请点击下方按钮添加',
      addLineCode: '+ 添加线路代码',
      allLinesAdded: '线路已全部添加',
      selectSupplierFirst: '请先选择供应商',
      selectAtLeastOneLine: '请至少添加一条线路代码',
      containerLinesAdded: '该供应商在本箱型下的线路已全部添加',
      routeLinesAdded: '该供应商线路已全部添加',
      completeCurrentWinner: '请先完善当前中标人',
      containerWinnerLimit: '该箱型最多 {count} 个中标供应商',
      routeWinnerLimit: '最多 {count} 个中标供应商',
      noMoreSupplier: '无更多可选供应商',
      candidateMeta: '有效期 {validity} · {count} 个线路代码'
    },
    notification: {
      title: '确认中标结果与通知',
      mailOptional: '邮件通知为可选项，默认关闭'
    },
    review: {
      title: '中标结果',
      count: '共 {count} 条中标报价',
      transportMode: '运输方式',
      route: '航线',
      container: '箱型',
      supplier: '中标供应商',
      price: '中标价格',
      percentage: '中标比例',
      lineCodes: '线路代码',
      empty: '暂无中标分配'
    },
    mail: {
      recipientCount: '{count} 家可发送',
      template: '邮件模板',
      templatePlaceholder: '请选择邮件模板',
      subject: '邮件主题',
      subjectPlaceholder: '请输入邮件主题',
      content: '邮件正文',
      contentPlaceholder: '请输入邮件正文',
      companies: '发送公司',
      companiesPlaceholder: '请选择发送公司',
      noEmail: '未填写邮箱',
      awardCount: '· {count} 条中标',
      disabled: '本次定标不发送此类邮件',
      preview: '邮件内容预览',
      previewRecipient: '预览对象：{supplier}',
      previewSubject: '主题：',
      previewEmpty: '请先选择发送公司以生成个性化预览',
      winner: { title: '发送中标通知邮件（含线路/价格，按供应商单独发送）' },
      thankYou: { title: '发送感谢信邮件（未中标供应商，不含他人中标信息）' }
    },
    confirm: {
      title: '确认提交定标',
      content: '提交后将锁定中标结果，并把中标报价直接写入运价库。确认继续吗？'
    },
    tasks: {
      emailTitle: '邮件发送',
      count: '共 {count} 个任务',
      status: '状态',
      retryCount: '重试次数',
      lastError: '最近错误',
      operation: '操作',
      emailType: '邮件类型',
      supplier: '收件公司',
      emailTypes: { WINNER: '中标通知', THANK_YOU: '未中标感谢信' },
      emailStatuses: {
        PENDING: '等待发送', SENDING: '发送中', RETRY: '等待重试', SENT: '发送成功', FAILED: '发送失败', CANCELLED: '已取消'
      }
    },
    messages: {
      loadFailed: '定标数据加载失败，请刷新后重试',
      templateLoadFailed: '邮件模板加载失败，请稍后重试',
      dimensionRequired: '请为“{dimension}”设置至少一条中标报价',
      winnerLimit: '“{dimension}”最多只能设置 {count} 家中标供应商',
      supplierRequired: '请为“{dimension}”选择中标供应商',
      quoteRequired: '“{dimension}”存在未选择候选报价的分配行',
      percentageInvalid: '“{dimension}”的中标比例必须是 1 至 100 的整数',
      lineCodeRequired: '请为“{dimension}”选择至少一个线路代码',
      lineCodeInvalid: '“{dimension}”包含不属于当前报价的线路代码',
      duplicateSupplier: '“{dimension}”不能重复选择同一家供应商',
      supplierPercentageMismatch: '“{dimension}”中供应商“{supplier}”的多条中标报价必须使用相同中标比例',
      duplicateQuote: '同一报价行不能重复分配',
      percentageExceeded: '“{dimension}”的比例合计为 {total}%，不能超过 100%',
      allocationRequired: '请设置至少一条中标报价',
      mailContentRequired: '请补全“{type}”的模板、主题和正文',
      mailSupplierRequired: '请为“{type}”选择至少一家有效收件公司',
      mailSupplierInvalid: '“{type}”包含不在合法范围内或缺少邮箱的收件公司',
      saveSuccess: '定标草稿已保存',
      saveFailed: '定标草稿保存失败，请刷新后重试',
      commitSuccess: '定标提交成功',
      commitFailed: '定标提交失败，请检查数据或刷新后重试',
      retrySubmitted: '重试任务已提交',
      retryFailed: '重试提交失败，请稍后重试'
    }
  },
  supplierBid: {
    languageSwitch: 'English',
    title: '应标报价编辑：{title}（{code}）',
    detailTitle: '应标详情：{title}（应标标书号：{code}）',
    detailDefaultTitle: '应标详情',
    defaultTitle: '应标编辑',
    status: { draft: '草稿', submitted: '已提交' },
    actions: {
      saving: '保存中...', saveDraft: '保存草稿', submitting: '提交中...', submit: '提交应标',
      download: '下载', delete: '删除', close: '关闭', cancel: '取消', confirm: '确定',
      history: '历史报价', batchImport: '批量导入报价', addQuote: '新增报价行', removeQuote: '删除报价行',
      exportCurrent: '导出当前页签模板', exportTemplate: '导出报价模板', exportCsv: '导出为 CSV',
      confirmSubmit: '确认提交', checkAgain: '再检查一下'
    },
    loading: '正在加载应标信息...',
    invalidLinkHelp: '请联系招标方重新获取邀请链接',
    submittedHint: '本轮应标已于 {time} 提交，按照招标规则不可再次修改。',
    readonlyHint: '当前不在可应标时间内，页面仅供查看。应标时间：{start} 至 {end}。',
    sections: {
      basic: '基本信息', tenderRemark: '备注说明', tenderAttachments: '招标附件',
      supplier: '应标公司信息', bidRemark: '应标备注', upload: '文件上传', routes: '航线信息与报价'
    },
    fields: {
      tenderCode: '招标编号', tenderCompany: '招标单位', tenderType: '招标类型', cargoType: '货品类型', tenderRound: '招标轮次',
      biddingMethod: '招标方式', bidNumber: '应标编号', tenderNumber: '招标编号关联', bidStatus: '应标状态',
      roundValue: '第 {current} / {total} 轮', startTime: '招标开始时间', endTime: '招标结束时间',
      requireDeposit: '是否缴纳保证金', depositAmount: '保证金金额', depositDeadline: '保证金缴纳截止时间',
      supplierName: '应标公司名称', contact: '联系人', email: '邮箱', none: '无'
    },
    placeholders: { contact: '请输入联系人', email: '请输入邮箱', remark: '选填，请输入应标备注', input: '请输入', select: '请选择', scheme: '请选择招标方案', container: '请选择箱型', carrier: '请选择', warehouse: '请选择仓库', searchPort: '输入代码或名称搜索', searchKeyword: '输入关键字搜索', noCarrier: '暂无可用承运人', noPort: '暂无可用港口', noTransitLocation: '暂无匹配的港口或机场', noSearchResult: '暂无匹配项', noWarehouse: '暂无可用仓库', weekday: '请选择' },
    common: { yes: '是', no: '否' },
    tenderTypes: { year: '年度招标', quarter: '季度招标', month: '月度招标' },
    serviceTypes: { economy: '经济', express: '快速' },
    routingTypes: { direct: '直航', transit: '中转' },
    attachments: {
      bid: '应标附件', uploaded: '已上传文件（{count}）', fileName: '文件名', uploadTime: '上传时间', operation: '操作',
      emptyTender: '暂无招标附件', emptyBid: '暂无文件', drop: '点击或拖拽文件到此区域上传',
      formats: '支持 PDF、Word、Excel、图片格式', size: '单个文件不超过 10MB',
      depositHint: '提示：如已缴纳保证金，请上传保证金凭证'
    },
    route: {
      helpTitle: '区域说明', helpLocked: '招标已填字段锁定，运价有效期、线路信息及各项费用由供应商填写。',
      helpOptional: '各项费用选填项默认金额为 0；实际产生的费用请如实填写。',
      helpRows: '默认按招标箱型各一行；勾选参与应标，保存与提交仅针对已选记录。',
      exportHintPrefix: '导出报价模板：下方表格内', exportHintCell: '任意数据单元格', exportHintMiddle: '右键 → 导出 →',
      exportHintExcel: '导出为 Excel / CSV', exportHintSuffix: '；填好后可点「批量导入报价」上传。',
      selectedAll: '已选择 {count} 条报价记录；保存草稿和提交应标时将同步这些选择。',
      requiredFee: '* 为必填费用', footer: '共 {total} 条报价记录，已选择 {selected} 条',
      schemeTooltip: '招标方案构成：起运国-起运港/机场-起运地（城市）-起运仓库-目的国-目的港/机场-目的地（城市）-目的仓库；仅展示招标已填项',
      transitPortTooltip: '中转时可多选港口或机场',
      weekdayTooltip: '可多选；D1为周一，D7为周日，保存格式为D1/D3/D5'
    },
    weekdays: { d1: 'D1 周一', d2: 'D2 周二', d3: 'D3 周三', d4: 'D4 周四', d5: 'D5 周五', d6: 'D6 周六', d7: 'D7 周日' },
    modes: { fcl: '海运整箱（FCL）', lcl: '海运拼箱（LCL）', air: '空运（AIR）' },
    feeGroups: { validity: '运价有效期', transit: '线路信息', origin: '港前', basic: '干线', destination: '尾程' },
    feeLimits: { min: 'Min', max: 'Max', minHeader: '{fee}MIN', maxHeader: '{fee}MAX', minTooltip: '{fee} · 下限', maxTooltip: '{fee} · 上限' },
    columns: {
      index: '序号', scheme: '招标方案', originCountry: '起运国', originPort: '起运港', originAirport: '起运机场',
      originCity: '起运地（城市）', originWarehouse: '发货仓库', destinationCountry: '目的国', destinationPort: '目的港',
      destinationAirport: '目的机场', destinationCity: '目的地（城市）', destinationWarehouse: '目的仓库',
      serviceType: '服务类型', transportClause: '运输条款', tradeClause: '贸易条款', tenderRemark: '招标备注',
      routingType: '运输方式*', transitPort: '中转港', transitAirport: '中转机场',
      weight: '重量(kg)', cbm: '体积(CBM)', containerType: '箱型', minPrice: '最低限价', maxPrice: '最高限价', quantity: '数量(箱)',
      effectiveDate: '生效日期*', expiryDate: '截止日期*', airline: '航空公司*', carrier: '船公司*',
      flightSchedule: '航班表*\nWeekday', sailingSchedule: '班轮时间*\nWeekday', transitDays: '运输周期*\nDays',
      airFreeStorage: '目的机场免存期*\nHrs', cfsFreeStorage: 'CFS仓库免存期*\nHrs', achievement: '时效达成率*\n%',
      portFreeDetention: '目的港免柜期*\nDays', portFreeStorage: '目的港免堆期*\nDays', clearanceDays: '目的港清关时间*\nDays',
      overallAchievement: '综合时效达成率*\n%', bidRemark: '应标备注'
    },
    history: { time: '操作时间', operator: '操作人', type: '操作类型', remark: '备注', empty: '暂无历史报价' },
    import: {
      exportTitle: '导出报价模板', exportTip: '请在报价表格任意数据单元格上右键，选择导出 Excel 或 CSV；填写后在此上传。模板仅包含当前页签现有报价行，需要更多报价时请先在页面新增报价行并选择招标方案。Excel 中招标只读单元格已锁定，导入时同样不允许修改招标原值。',
      uploadTitle: '上传文件', dropPrefix: '拖拽文件到此处或', click: '点击上传',
      format: '支持 .xls、.xlsx、.csv 文件', recognized: '已识别 {count} 条报价',
      scanSummary: '共扫描 {total} 条数据',
      importableSummary: '可导入 {count} 条',
      issueSummary: '{count} 条存在问题，查看详情',
      validating: '校验中...'
    },
    importErrors: {
      title: '导入校验未通过',
      summary: '共发现 {count} 个问题。整批报价尚未回填，请修正文件后重新导入。',
      summaryPartial: '共发现 {count} 个问题。当前仍有 {valid} 条报价可导入，可先导入无问题数据。',
      sheet: '工作表',
      row: '行',
      column: '字段',
      value: '原始值',
      reason: '问题说明',
      currentDuplicate: '该报价行除应标备注外的填写信息与当前页面其他报价行一致，请去重',
      originalRowMissing: '模板中的原报价行已不存在，请重新导出模板后填写'
    },
    messages: {
      invalidLink: '链接缺少招标信息或企业专属令牌，无法打开应标页面', contactRequired: '请输入联系人',
      emailInvalid: '请输入有效的联系邮箱', quoteRequired: '请至少选择一条航线或箱型参与报价',
      validityRequired: '请填写航线 {route} 的运价有效期', dateOrderInvalid: '航线 {route} 的截止日期不能早于生效日期',
      feeBoundsInvalid: '费用 {fee} 的 Min/Max 必须为非负数，且 Min 不能大于 Max',
      feeRequired: '请填写航线 {route} 的必填费用：{fee}', draftSaved: '草稿保存成功', submitTitle: '确认提交投标',
      submitContent: '提交后本轮应标不可再修改，请确认报价内容无误。', submitted: '应标提交成功',
      noScheme: '暂无可选择的{mode}招标方案', schemeRequired: '请先为新增报价行选择招标方案',
      containerRequired: '请选择招标方案 {route} 下的箱型', portsRequired: '请选择招标方案 {route} 的起运港和目的港',
      duplicateQuote: '招标方案 {route} 存在除应标备注外的填写信息一致的重复报价，请去重后提交',
      duplicateQuoteRows: '第 {rows} 行存在除应标备注外的填写信息一致的重复报价，请去重。可以先保存草稿。',
      selectDelete: '请先勾选要删除的报价行',
      transitRequired: '请完整填写航线 {route} 的线路信息', ddRequired: '请完整填写航线 {route} 的 POD D&D 信息',
      achievementRateRangeInvalid: '航线 {route} 的综合时效达成率必须在 0～100 之间',
      fileTooLarge: '{name} 超过10MB，已跳过', uploadSuccess: '文件上传成功，请保存草稿或提交应标',
      xlsxRequired: '请上传 .xls、.xlsx 或 .csv 文件', sheetMissing: '文件中没有工作表', parsed: '已识别 {count} 条报价',
      parsedNone: '未识别到可导入的报价，请查看问题明细后修正文件',
      parsedPartial: '已识别 {valid} 条可导入报价，{invalid} 条存在问题',
      imported: '已导入 {count} 条报价，请保存草稿或提交应标',
      importedPartial: '已导入 {applied} 条报价，{skipped} 条因与当前页面重复未导入', carrierImportUnmatched: '有 {count} 条报价的承运人名称未匹配当前租户基础资料，请在表格中重新选择',
      scheduleImportInvalid: '有 {count} 条报价的班轮时间或航班表不符合D1-D7格式，请在表格中重新选择', requestFailed: '请求失败，请稍后重试'
    },
    excel: {
      quoteId: '报价行标识', participating: '参与报价', routeCode: '航线编码', containerType: '箱型', originPort: '起运港/机场', originPortFcl: '起运港', originAirport: '起运机场', destinationPort: '目的港/机场', destinationPortFcl: '目的港', destinationAirport: '目的机场', routingType: '运输方式', transitPort: '中转港/机场', transitPortFcl: '中转港', transitAirport: '中转机场', effectiveDate: '生效日期',
      expiryDate: '截止日期', carrier: '承运人', shipper: '船公司', transitCarrier: '航空公司', schedule: '船期/航班', vesselSchedule: '班轮时间', flightSchedule: '航班表', bidRemark: '应标备注', fileSuffix: '报价模板', instructionMarker: '填写说明：星号请必填', readOnly: '只读',
      instructions: {
        singleSelect: '必填单选',
        seaport: '有值只读；空值必填代码（五字码）',
        airport: '有值只读；空值必填代码（三字码）',
        routingType: '必填单选；中转/直航',
        transitSeaport: '中转必填单选；代码（五字码）',
        transitAirport: '中转必填单选；代码（三字码）',
        date: 'yyyy-mm-dd', carrier: '代码', airline: '代码（二字码）',
        schedule: '多选D1到D7；\n例，D1/D7', number: '数字', amount: '数字（请保留两位小数）'
      },
      transitDays: '运输周期(Days)',
      airFreeStorage: '目的机场免存期(Hrs)', cfsFreeStorage: 'CFS仓库免存期(Hrs)', achievement: '时效达成率(%)',
      portFreeDetention: '目的港免柜期(Days)', portFreeStorage: '目的港免堆期(Days)', clearanceDays: '目的港清关时间(Days)',
      overallAchievement: '综合时效达成率(%)'
    }
  }
}
